class AddFreeGift {
  constructor() {
     this.init();
  }

  addProduct = async (productData) => {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "items": productData })
      })
      const data = await response.json();
    } catch (error) {
      console.error('Error adding product:', error);
    }
  }
  removeItem = async (items) => {
    if (items.length > 0) {
      let item = items.pop();
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(item)
        })
        const data = await response.json();
        if (items.length > 0) {
          this.removeItem(items)
        }
      } catch (error) {
        console.error('Error adding product:', error);
      }
    }
  }


  freeGiftUpdate = async (cart) => {
    let total_price = Number(cart.total_price);
    let items = window.freeGifts;
    let changed = false;
    let addItems = []
    let removeItems = []

    let freeGift1 = null;
    let freeGift2 = null;
    if(items.length >  0){
      freeGift1 = items[0]
    }
    if(items.length >  1){
      freeGift2 = items[1]
    }

    let exist1 = null;
    let exist1Index = null;
    let exist2 = null;
    let exist2Index = null;
    if(freeGift1){
      exist1 = cart.items.find((lineItem) => lineItem.variant_id == freeGift1.id && lineItem.properties['_free_gift'] == true);
      exist1Index = cart.items.findIndex((lineItem) => lineItem.variant_id == freeGift1.id && lineItem.properties['_free_gift'] == true);
    }

    if(freeGift2){
      exist2 = cart.items.find((lineItem) => lineItem.variant_id == freeGift2.id && lineItem.properties['_free_gift'] == true);
      exist2Index = cart.items.findIndex((lineItem) => lineItem.variant_id == freeGift2.id && lineItem.properties['_free_gift'] == true);
    }

    // if(exist1){
    //   total_price = total_price - exist1.price
    // }
    // if(exist2){
    //   total_price = total_price - exist2s.price
    // }

    if(freeGift2){
      let price = total_price;
      if(exist1){
        price = price - exist1.line_price
      }
      if(exist2){
        price = price - exist2.line_price
      }
      if (!exist2 && price >= freeGift2.price) {
        changed = true
        addItems.push({
          'id': freeGift2.id,
          'quantity': 1,
          'properties': { "_free_gift": true }
        })
      } else if (exist2 && (price < freeGift2.price)) {
        changed = true
        removeItems.push({
          'line': (exist2Index+1),
          'quantity': 0
        })
      }else if (exist2 && exist2.quantity > 1) {
        changed = true
        removeItems.push({
          'line': (exist2Index+1),
          'quantity': 0
        })
      }
  }


    if(freeGift1){
        let price = total_price;
      if(exist1){
        price = price - exist1.line_price
      }
        if(exist2){
          price = price - exist2.line_price
        }
        if(freeGift2){
          if (!exist1 && price >= freeGift1.price && price < freeGift2.price) {
            changed = true
            addItems.push({
              'id': freeGift1.id,
              'quantity': 1,
              'properties': { "_free_gift": true }
            })
          } else if (exist1 && price >= freeGift2.price) {
            changed = true
            removeItems.push({
              'line': (exist1Index+1),
              'quantity': 0
            })
          }else if (!exist2 && !exist1 && price >= freeGift1.price && price < freeGift2.price) {
            changed = true
            addItems.push({
              'id': freeGift1.id,
              'quantity': 1,
              'properties': { "_free_gift": true }
            })
          } else if (exist1 && price < freeGift1.price) {
            changed = true
            removeItems.push({
              'line': (exist1Index+1),
              'quantity': 0
            })
          }else if (exist1 && exist1.quantity > 1) {
            changed = true
            removeItems.push({
              'line': (exist1Index+1),
              'quantity': 0
            })
          }
        }else{
          if (!exist1 && price >= freeGift1.price) {
            changed = true
            addItems.push({
              'id': freeGift1.id,
              'quantity': 1,
              'properties': { "_free_gift": true }
            })
          } else if (exist1 && price < freeGift1.price) {
            changed = true
            removeItems.push({
              'line': (exist1Index+1),
              'quantity': 0
            })
          }else if (exist1 && exist1.quantity > 1) {
            changed = true
            removeItems.push({
              'line': (exist1Index+1),
              'quantity': 0
            })
          }
      }
    }

    


    console.log("addItems", addItems)
    console.log("removeItems", removeItems)

    if (addItems.length > 0) {
      window.freeGiftLoading = false;
      await this.addProduct(addItems)
      window.updateQuickCart()
      return
    }

    if (removeItems.length > 0) {
      window.freeGiftLoading = false;
      await this.removeItem(removeItems)
      window.updateQuickCart()
      return
    }
    

    // return changed
  }

  init = async () => {
    // return;  
    if (!window.freeGiftLoading && window.freeGifts.length > 0) {
      window.freeGiftLoading = true
      try {
        const res = await fetch('/cart.json');
        const cart = await res.json();
        const update = await this.freeGiftUpdate(cart);
        window.freeGiftLoading = false
      } catch (e) {
        console.log("error",e)
        window.freeGiftLoading = false
        return false;
      }
    }
  }
}

window.freeGiftPromo = new AddFreeGift();
window.freeGiftPromo.init();